import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode?.debug;

const BASE_PATH = "/api/mail-logs";

/**
 * Szuka wysyłek na wskazany adres w opcjonalnym zakresie dat.
 * @param {string} toEmail
 * @param {string|undefined} fromYmd
 * @param {string|undefined} toYmd
 * @param {number} limit
 * @param {string} accessToken
 * @returns {Promise<Array>}
 */

export async function searchMailLogs(email, from, to, limit = 200, token) {
  const params = new URLSearchParams();
  if (email) params.set("email", email);
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (limit) params.set("limit", String(limit));

  const res = await axios.get(`${ApiHost}${BASE_PATH}/search`, {
    params,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return res.data?.items ?? [];
}

/**
 * Pobiera pełny ślad logów dla danego QueueId.
 * @param {string} queueId
 * @param {string} accessToken
 * @returns {Promise<Array>}
 */
export async function getMailTrace(queueId, accessToken) {
  if (debug) logger.log("[mailLogsApi] trace", queueId);
  const res = await axios.get(
    `${ApiHost}${BASE_PATH}/trace/${encodeURIComponent(queueId)}`,
    {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    }
  );
  return res.data?.items ?? [];
}


